 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		var head = document.getElementsByTagName('head')[0];
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');
 				link.crossOrigin = "anonymous";
 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"bundles/project.js": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	var dlbs = [{"name":"head-dlb/bundle.production.js","path":"head-dlb/static-1.368/bundle.production.js","ids":{}},{"name":"hubspot-dlb/bundle.production.js","path":"hubspot-dlb/static-1.427/bundle.production.js","ids":{"enviro":3}},{"name":"reporting-dlb/bundle.production.js","path":"reporting-dlb/static-1.25620/bundle.production.js","ids":{}},{"name":"apollo-dlb/bundle.production.js","path":"apollo-dlb/static-2.80/bundle.production.js","ids":{}}];
 	__webpack_require__.dlbpr = function(dlbId, id) {
 	  var dlb = dlbs[dlbId];
 	  if (!dlb.r) {
 	    dlb.r = window['__webpack_require_' + dlb.name + '__'];
 	    if (!dlb.r) {
 	      throw new Error('dlb ' + dlb.name + ' not loaded');
 	    }
 	    // the first time a dlb module is required, we link it
 	    dlb.r.linkDlb(__webpack_require__, dlb.ids);
 	  }
 	  return dlb.r(id);
 	}
 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				// preload script via HighPriorityFetchPlugin
 				var link = document.createElement('link');

 				link.charset = 'utf-8';
 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "preload";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				if (link.href.indexOf(window.location.origin + '/') !== 0) {
 					link.crossOrigin = "anonymous";
 				}
 				document.head.appendChild(link);
 				// end preload
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//static.hsappstatic.net/content-detail-ui/static-1.35836/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	webpackJsonpCallback([[], {}, 0, ["InternalLinksContainer~KeywordSection~OptimizationContentPanel~header~performance~personalization~pe~c1492082","InternalLinksContainer~KeywordSection~OptimizationContentPanel~performance~personalization~personali~ab483c1b","InternalLinksContainer~KeywordSection~OptimizationContentPanel~campaign-edit-panel-body~chunk-modals~735edfe4","campaign-edit-panel-body~chunk-modals~performance~personalization~personalizationResults~smart-conte~73f1284d","KeywordSection~header~performance~personalization~personalizationResults~smart-content~variations","KeywordSection~campaign-edit-panel-body~chunk-modals~performance~smart-content~variations","performance~reporting-data__inboundDb~reporting-data__main~reporting-data__unified~smart-content~var~9a42255b","campaign-edit-panel-body~performance~personalization~personalizationResults~smart-content~variations","performance~personalization~personalizationResults~smart-content~variations","performance~reporting-data__inboundDb~reporting-data__main~smart-content~variations","InternalLinksContainer~header~performance~smart-content~variations","header~object-builder-client~performance~smart-content~variations","campaign-edit-panel-body~header~performance~smart-content~variations","performance~reporting-data__custom~reporting-data__main~smart-content~variations","campaign-edit-panel-body~chunk-modals~performance~smart-content~variations","reporting-data__main","campaign-edit-panel-body~performance~smart-content~variations","header~performance~smart-content~variations","InternalLinksContainer~performance~smart-content~variations","KeywordSection~performance~smart-content~variations","chunk-modals~performance~smart-content~variations","campaign-edit-panel~performance~smart-content~variations","performance~smart-content~variations","header~performance","performance"]]);
 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2563);
